module.exports = __webpack_public_path__ + "src/app/assets/images/scalac.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/scalac.png
// module id = 626
// module chunks = 0